export const TypographyClasses = {
  ".display-3-b": {
    "@apply tw-font-abc-social tw-text-160 tw-font-bold tw-leading-160 tw-tracking-tight-2":
      {},
  },
  ".display-2-b": {
    "@apply tw-font-abc-social tw-text-88 tw-font-bold tw-leading-96 tw-tracking-tight-1":
      {},
  },
  ".display-1": {
    "@apply tw-font-abc-social tw-text-56 tw-font-book tw-leading-64 tw-tracking-tight-1":
      {},
  },
  ".display-1-m": {
    "@apply tw-font-abc-social tw-text-56 tw-font-medium tw-leading-64 tw-tracking-tight-1":
      {},
  },
  ".display-1-b": {
    "@apply tw-font-abc-social tw-text-56 tw-font-bold tw-leading-64 tw-tracking-tight-1":
      {},
  },

  ".headline-6": {
    "@apply tw-font-abc-social tw-text-40 tw-font-regular tw-leading-48": {},
  },
  ".headline-6-underline": {
    "@apply tw-font-abc-social tw-text-40 tw-font-regular tw-leading-48 tw-underline":
      {},
  },
  ".headline-6-m": {
    "@apply tw-font-abc-social tw-text-40 tw-font-medium tw-leading-48": {},
  },
  ".headline-6-b": {
    "@apply tw-font-abc-social tw-text-40 tw-font-bold tw-leading-48": {},
  },
  ".headline-5": {
    "@apply tw-font-abc-social tw-text-32 tw-font-book tw-leading-40": {},
  },
  ".headline-5-underline": {
    "@apply tw-font-abc-social tw-text-32 tw-font-book tw-leading-40 tw-underline":
      {},
  },
  ".headline-5-m": {
    "@apply tw-font-abc-social tw-text-32 tw-font-medium tw-leading-40": {},
  },
  ".headline-5-b": {
    "@apply tw-font-abc-social tw-text-32 tw-font-bold tw-leading-40": {},
  },
  ".headline-4": {
    "@apply tw-font-abc-social tw-text-28 tw-font-bold tw-leading-32": {},
  },
  ".headline-4-m": {
    "@apply tw-font-abc-social tw-text-28 tw-font-medium tw-leading-32": {},
  },
  ".headline-4-b": {
    "@apply tw-font-abc-social tw-text-28 tw-font-bold tw-leading-32": {},
  },
  ".headline-3-m": {
    "@apply tw-font-abc-social tw-text-24 tw-font-medium tw-leading-30": {},
  },
  ".headline-3-b": {
    "@apply tw-font-abc-social tw-text-24 tw-font-bold tw-leading-30": {},
  },
  ".headline-2-m": {
    "@apply tw-font-abc-social tw-text-20 tw-font-medium tw-leading-24": {},
  },
  ".headline-2-m-underline": {
    "@apply tw-font-abc-social tw-text-20 tw-font-medium tw-leading-24 tw-underline":
      {},
  },
  ".headline-1-m": {
    "@apply tw-font-abc-social tw-text-18 tw-font-medium tw-leading-24": {},
  },

  ".body-4": {
    "@apply tw-font-abc-social tw-text-20 tw-font-book tw-leading-24": {},
  },
  ".body-3": {
    "@apply tw-font-abc-social tw-text-18 tw-font-book tw-leading-24": {},
  },
  ".body-3-long": {
    "@apply tw-font-abc-social tw-text-20 tw-font-book tw-leading-28": {},
  },
  ".body-2": {
    "@apply tw-font-abc-social tw-text-16 tw-font-book tw-leading-24": {},
  },
  ".body-2-underline": {
    "@apply tw-font-abc-social tw-text-16 tw-font-book tw-leading-24 tw-underline":
      {},
  },
  ".body-2-m": {
    "@apply tw-font-abc-social tw-text-16 tw-font-medium tw-leading-24": {},
  },
  ".body-2-m-underline": {
    "@apply tw-font-abc-social tw-text-16 tw-font-medium tw-leading-24 tw-underline":
      {},
  },
  ".body-1": {
    "@apply tw-font-abc-social tw-text-14 tw-font-book tw-leading-16": {},
  },
  ".body-1-long": {
    "@apply tw-font-abc-social tw-text-14 tw-font-book tw-leading-20": {},
  },
  ".body-1-underline": {
    "@apply tw-font-abc-social tw-text-14 tw-font-book tw-leading-20 tw-underline":
      {},
  },
  ".body-1-m-long": {
    "@apply tw-font-abc-social tw-text-14 tw-font-medium tw-leading-20": {},
  },
  ".body-1-m": {
    "@apply tw-font-abc-social tw-text-14 tw-font-medium tw-leading-16": {},
  },

  ".caption-2": {
    "@apply tw-font-abc-social tw-text-12 tw-font-book tw-leading-16": {},
  },
  ".caption-2-m": {
    "@apply tw-font-abc-social tw-text-12 tw-font-medium tw-leading-16": {},
  },
  ".caption-1": {
    "@apply tw-font-abc-social tw-text-10 tw-font-book tw-leading-16": {},
  },
  ".caption-1-b": {
    "@apply tw-font-abc-social tw-text-10 tw-font-bold tw-leading-16": {},
  },

  ".mono-3": {
    "@apply tw-font-abc-social-mono tw-text-14 tw-font-regular tw-leading-20 tw-uppercase":
      {},
  },
  ".mono-2": {
    "@apply tw-font-abc-social-mono tw-text-12 tw-font-regular tw-leading-16 tw-uppercase":
      {},
  },
  ".mono-1": {
    "@apply tw-font-abc-social-mono tw-text-10 tw-font-regular tw-leading-14 tw-uppercase":
      {},
  },
  ".druk-1-b": {
    "@apply tw-font-druk tw-text-56 tw-font-bold tw-leading-64 tw-uppercase":
      {},
  },
  ".druk-2-b": {
    "@apply tw-font-druk tw-text-40 tw-font-bold tw-leading-40 tw-uppercase":
      {},
  },
  ".druk-headline-1": {
    "@apply tw-font-druk tw-text-40 tw-font-medium tw-leading-36 tw-uppercase":
      {},
  },
  ".druk-headline-2": {
    "@apply tw-font-druk tw-text-48 tw-font-medium tw-leading-44 tw-uppercase":
      {},
  },
  ".druk-headline-3": {
    "@apply tw-font-druk tw-text-56 tw-font-medium tw-leading-52 tw-uppercase":
      {},
  },
} as const;

// Programmatically generate the type
export type Typeface = keyof typeof TypographyClasses extends `.${infer Key}`
  ? Key
  : never;
